class PasswordHelper {

    static passwordContainsDictionaryWord(password) {
        return Object.prototype.hasOwnProperty.call(this.WORDS, password);
    }

    static WORDS = require('@/assets/words.json');
}

export default PasswordHelper;